import { Modal, FormField } from '@chikara/ui';
import { formatCurrency } from '@chikara/utils';
import { useManageLimitForm } from './useManageLimitForm';
import { Card } from '@/features/card/types/card.types';
import styles from './ManageLimitModal.module.css';
import { t } from '@/i18n';

interface ManageLimitModalProps {
    isOpen: boolean;
    card: Card;
    onClose: () => void;
    onSuccess: () => void;
}
const formatMXN = (value: number) => formatCurrency(value, { locale: 'es-MX', currency: 'MXN' });

export const ManageLimitModal = ({
    isOpen,
    card,
    onClose,
    onSuccess,
}: ManageLimitModalProps) => {
    const {
        inputValue,
        globalAvailable,
        availableToAssign,
        localError,
        isActionDisabled,
        handleInputChange,
        handleSave,
    } = useManageLimitForm({ isOpen, onClose, card, onSuccess });

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.manageLimit.title')}
            actionLabel={t('dashboard.card.detail.modals.manageLimit.save')}
            onAction={handleSave}
            isActionDisabled={isActionDisabled}
            secondaryActionLabel={t('dashboard.card.detail.modals.manageLimit.cancel')}
            onSecondaryAction={onClose}
        >
            <div className={styles.wizardContent}>
                <p className={styles.infoText}>
                    {t('dashboard.card.detail.modals.manageLimit.info')}
                </p>

                <FormField
                    label={t('dashboard.card.detail.modals.manageLimit.inputLabel')}
                    value={inputValue}
                    onChange={handleInputChange}
                    error={localError || undefined}
                    className={localError ? styles.errorInput : ''}
                />

                <div className={styles.financeSummary}>
                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>
                            {t('dashboard.card.detail.modals.manageLimit.totalAccountLimit')}
                        </span>
                        <span className={styles.summaryValue}>
                            {formatMXN(globalAvailable)}
                        </span>
                    </div>
                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>
                            {t('dashboard.card.detail.modals.manageLimit.availableToAssign')}
                        </span>
                        <span className={styles.summaryValue}>
                            {formatMXN(availableToAssign)}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
